import { type Framework } from '@toeverything/infra';

import { WorkspaceDBService } from '../db';
import { WorkspaceScope } from '../workspace';
import { FolderNode } from './entities/folder-node';
import { FolderTree } from './entities/folder-tree';
import { OrganizeService } from './services/organize';
import { FolderStore } from './stores/folder';
import { WorkbenchService } from '../workbench';
import { DocsService } from '../doc';
import { AgentBetaStore } from '../ys-ai/stores/agent-store-beta';
import { DocDisplayMetaService } from '../doc-display-meta';
import { DocTitleUniquenessService } from './services/doc-title-uniqueness';

export type { FolderNode } from './entities/folder-node';
export { DocTitleUniquenessService } from './services/doc-title-uniqueness';
export { OrganizeService } from './services/organize';

export function configureOrganizeModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(DocTitleUniquenessService, [DocsService, DocDisplayMetaService])
    .service(OrganizeService, [
      DocsService,
      WorkbenchService,
      AgentBetaStore,
      DocTitleUniquenessService,
    ])
    .entity(FolderTree, [FolderStore])
    .entity(FolderNode, [FolderStore])
    .store(FolderStore, [WorkspaceDBService]);
}
